import * as React from "react";

/**
 * provides a hook to execute code when the component mounts and unmounts.
 *
 * @param mount function to call when the component mounts
 * @param unmount function to call when the component unmounts.
 */
export const useOnMount = (mount: () => void, unmount?: () => void) => {
    React.useEffect(() => {
        mount();
        if (unmount) {
            return unmount;
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []); // has no dependencies. runs only on mount
};
